import { render, staticRenderFns } from "./ScoutUnderReview.vue?vue&type=template&id=4534cd7a"
import script from "./ScoutUnderReview.vue?vue&type=script&lang=js"
export * from "./ScoutUnderReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports